import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { distinctUntilChanged, tap, filter, switchMap } from 'rxjs/operators';

import { AbnService } from '../../../core/data';

@Component({
  selector: 'app-abn-input',
  templateUrl: './abn-input.component.html',
})
export class AbnInputComponent {
  @Input() className: string = 'form__edit';
  @Input() control: FormControl;
  @Output() nameChanges = new EventEmitter<string>();

  name = new ReplaySubject<string>();

  constructor(private abnService: AbnService) {}

  ngOnInit() {
    this.control.valueChanges.pipe(
      distinctUntilChanged(),
      tap(() => this.name.next(null)),
      filter(() => this.control.valid),
      switchMap(value => this.abnService.lookup(value.replace(/\D+/g, ''))),
    ).subscribe(
      lookup => this.name.next(lookup.name),
      () => this.name.next(''),
    );

    this.name.subscribe(name => this.nameChanges.emit(name));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/abn/abn-input.component.ts